// NAV-2 — **THE MOUNT FOR THE BOTTOM BAR'S SELF-HEALING WATCHDOG.** It draws nothing.
//
// Her order's clause 2, in her own words: *"the bar checks its own bounding position on a slow
// heartbeat and on visibility/resume events, and if it ever finds itself unstuck it restores itself
// instantly — so even an unknown future cause can never strand it for more than a beat."*
//
// **EVERY LINE OF THE DECISION IS IN `src/navPin.js`, WHICH IMPORTS NOTHING**, so a `.mjs` gate
// LOADS and RUNS the drift, the heal and the teardown with no browser (R146: reach is transitive).
// What lives here is the WIRING and nothing else — this component is the one thing a fixture cannot
// hold, and it is one effect long on purpose (R8/R95: a decision inside an eleven-thousand-line file
// is a decision no gate can reach).
//
// It is its own component rather than an effect in the shell for the same reason: the shell is where
// a law goes to become unreadable.
import { useEffect } from "react";
import { watchNavPin } from "../navPin.js";

export function NavPinWatchdog() {
  useEffect(() => {
    // The element is found on EVERY check rather than captured once: the bar is portalled and
    // re-rendered, so a node held from mount time is a node that can stop being the one on screen.
    const stop = watchNavPin({ win: window, find: () => document.querySelector(".mobile-tab-bar") });
    return stop;
  }, []);
  return null;
}
